export const sensoryCommentLimit = 4000;
export const sensoryPresets = [
  { id: 'skincare', label: 'ผลิตภัณฑ์ดูแลผิว' },
  { id: 'sunscreen', label: 'กันแดด' },
  { id: 'edible', label: 'สินค้าที่รับประทานได้' },
  { id: 'other', label: 'อื่น ๆ' },
] as const;
export type SensoryPreset = (typeof sensoryPresets)[number]['id'];
export interface SensoryAnswer {
  score: string;
  note: string;
}
export type SensoryAnswers = Record<string, SensoryAnswer>;
const common = [
  { id: 'smell', label: 'กลิ่น' },
  { id: 'appearance', label: 'สี / ลักษณะ' },
  { id: 'texture', label: 'เนื้อสัมผัส' },
];
const skin = [
  { id: 'absorption', label: 'การซึม' },
  { id: 'spreadability', label: 'ความเกลี่ยง่าย' },
  { id: 'stickiness', label: 'ความเหนอะหนะ' },
  { id: 'afterfeel', label: 'ความรู้สึกหลังใช้' },
];
export function sensoryTraits(preset: SensoryPreset) {
  if (preset === 'edible')
    return [
      ...common,
      { id: 'taste', label: 'รสชาติ' },
      { id: 'aftertaste', label: 'รสที่ค้างในปาก' },
      { id: 'mixing', label: 'ความรู้สึกเมื่อผสม / ละลาย' },
    ];
  if (preset === 'other') return common;
  return [
    ...common,
    ...skin,
    ...(preset === 'sunscreen' ? [{ id: 'whitecast', label: 'คราบขาวหลังทา' }] : []),
  ];
}
export function applicableSensoryAnswers(
  preset: SensoryPreset,
  answers: SensoryAnswers,
): SensoryAnswers {
  return Object.fromEntries(
    sensoryTraits(preset).flatMap(({ id }) => (answers[id] ? [[id, answers[id]]] : [])),
  );
}
export function composeSensoryComment(
  comment: string,
  preset: SensoryPreset,
  answers: SensoryAnswers,
) {
  const lines: string[] = [];
  let invalidScore = false;
  for (const { id, label } of sensoryTraits(preset)) {
    const answer = answers[id];
    if (!answer) continue;
    const score = answer.score;
    if (score && !['1', '2', '3', '4', '5'].includes(score)) invalidScore = true;
    const note = answer.note.trim();
    if (!score && !note) continue;
    lines.push(
      `${label}: ${score ? `ความพึงพอใจ ${score}/5` : 'ยังไม่ให้คะแนน'}${note ? ` · ข้อสังเกต / สิ่งที่อยากปรับ: ${note}` : ''}`,
    );
  }
  const presetLabel = sensoryPresets.find((item) => item.id === preset)?.label ?? '';
  const feedback = lines.length
    ? `ความคิดเห็นจากการลองใช้ — ${presetLabel}\n${lines.join('\n')}`
    : '';
  const text = [comment, feedback].filter(Boolean).join('\n\n');
  return {
    text,
    remaining: sensoryCommentLimit - text.length,
    valid: !invalidScore && text.length <= sensoryCommentLimit,
  };
}
